module.exports = __webpack_public_path__ + "static/20200607-633232cff9b84bc13d5de0702fe8b4f0.webp";